enum PlatformType {
  AUDIT = 'audit',
  INSPECT = 'inspect',
  UNKNOWN = 'unknown',
}

let platform: PlatformType = PlatformType.UNKNOWN;

export const set = (value: PlatformType) => {
  platform = value;
};

const get = () => platform;

const isAudit = () => {
  return get() === PlatformType.AUDIT;
};

const isInspect = () => {
  return get() === PlatformType.INSPECT;
};

const Platform = {
  isAudit,
  isInspect,
  get,
  set,
};

export { PlatformType, Platform };
